export const ROOM_STAGE_PARTICIPANTS_CAPACITY = 9;
